export default "__VITE_ASSET__ByQttwsw__"